import React, { useState } from 'react';

export function fmt$(n) { return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
export function fmtLbs(n) { return Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 0 }) + ' lbs'; }
export function today() { return new Date().toISOString().slice(0, 10); }
export function daysDiff(dateStr) { return Math.round((new Date() - new Date(dateStr)) / 86400000); }

export function stockBadge(onHand, reorder) {
  // If no reorder point set, don't show any status
  if (!reorder || Number(reorder) === 0) return <span className="badge badge-gray">—</span>;
  if (onHand <= 0) return <span className="badge badge-danger">Out of stock</span>;
  if (onHand <= reorder) return <span className="badge badge-danger">Critical</span>;
  if (onHand <= reorder * 1.5) return <span className="badge badge-warn">Low</span>;
  return <span className="badge badge-ok">OK</span>;
}

export function stockPct(onHand, reorder) {
  if (!reorder || Number(reorder) === 0) return onHand > 0 ? 100 : 0;
  return Math.min(100, Math.round((onHand / (reorder * 2)) * 100));
}

export function stockBarColor(onHand, reorder) {
  if (!reorder || Number(reorder) === 0) return onHand > 0 ? '#16a34a' : '#9ca3af';
  if (onHand <= reorder) return '#dc2626';
  if (onHand <= reorder * 1.5) return '#d97706';
  return '#16a34a';
}

export function Modal({ title, onClose, onSave, children, saveLabel = 'Save' }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-head">
          <span className="modal-title">{title}</span>
          <button className="btn btn-sm" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-foot">
          <button className="btn" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={onSave}>{saveLabel}</button>
        </div>
      </div>
    </div>
  );
}

export function AdjustModal({ item, unit, onClose, onSave }) {
  const [amount, setAmount] = useState('');
  const [direction, setDirection] = useState('+');
  const [reason, setReason] = useState('');

  function save() {
    const val = parseFloat(amount);
    if (!val || val <= 0) { alert('Enter a valid amount.'); return; }
    onSave(direction === '+' ? val : -val, reason);
  }

  return (
    <Modal title={`Adjust — ${item.name || item.sku}`} onClose={onClose} onSave={save} saveLabel="Apply Adjustment">
      <div className="form-group">
        <label className="form-label">Direction</label>
        <div className="flex-row">
          <button className={`btn ${direction === '+' ? 'btn-primary' : ''}`} onClick={() => setDirection('+')}>+ Add</button>
          <button className={`btn ${direction === '-' ? 'btn-danger' : ''}`} onClick={() => setDirection('-')}>− Remove</button>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Amount ({unit})</label>
        <input className="form-input mono" type="number" min="0" step="any" value={amount} onChange={e => setAmount(e.target.value)} placeholder="0" autoFocus />
      </div>
      <div className="form-group">
        <label className="form-label">Reason (optional)</label>
        <input className="form-input" value={reason} onChange={e => setReason(e.target.value)} placeholder="e.g. Production run, received shipment, cycle count..." />
      </div>
    </Modal>
  );
}

export function useForm(initial) {
  const [form, setForm] = useState(initial);
  function set(field) { return e => setForm(f => ({ ...f, [field]: e.target.value })); }
  function reset() { setForm(initial); }
  return [form, set, setForm, reset];
}
